module.exports = __webpack_public_path__ + "static/media/card-lock-gold.e2433bf6.svg";